import apiClient from 'apiClient';
import { SaveData } from '../../../utils/api/types';

export const addAdmin = async (adminId: string) =>
  apiClient.post('/api/v1/broker-management/adviser-supports', {
    support_id: adminId,
  });

export const updateProfile = (values: SaveData): Promise<any> =>
  apiClient.post('/api/v1/broker-management/user-profile', values);
